import DatabaseService from 'services/DatabaseService.js';
import {processUserProfile} from 'actions/user.js';
import {processPinned, processChallenges, processSeasonChallenges} from 'actions/challenges.js';
import {processHistory} from 'actions/userChallenges.js';
import {processCards} from 'actions/cards.js';
import {processCarouselItems} from 'actions/carouselItems.js';



var defaultInclude = {userProfile:true, pinned:true, challenges:true, history:true, cards:true, categories:true, carousel:true};
export const fetchTimeline = (include=defaultInclude) => (dispatch, getState) => {
    return new Promise(function(resolve, reject) {
        DatabaseService.getTimeline(include).then( //timeline
            function(result) {
                console.log('fetchTimeline', result);

                if(include.userProfile) {
                    var userProfile = getState().user.userProfile || {};
                    processUserProfile(dispatch, { ...result.userProfile, 
                                                   company:userProfile.company });
                }

                if(include.pinned) {
                    processPinned(dispatch, result.pinned);
                }

                if(include.challenges) {
                    processChallenges(dispatch, result.challenges);
                }

                if(include.history) {
                    processHistory(dispatch, result.history);
                }

                if(include.cards) {
                    processCards(dispatch, result.cards);
                }

                if(include.carousel) {
                    processCarouselItems(dispatch, result.carousel);
                }

                resolve(result); 
            },
            function(error) {
                console.error(error);
                reject(error); 
            });
    });

}

export const fetchSeasonCategories = (seasonId) => (dispatch, getState) => {
    return new Promise(function(resolve, reject) {
        DatabaseService.getSeasonCategories(seasonId, {challenges: true}).then(
            function(result) {
                var categories = result.categories || [];
                var challenges = categories.reduce((a,category) => {
                    a = a.concat(category.challenges.map(c => ({...c, category:category})));
                    return a; 
                },[]);

                processSeasonChallenges(dispatch, challenges);

                resolve(result); 
            },
            function(error) {
                console.error(error);
                reject(error); 
            });
    });

}



// WEBPACK FOOTER //
// ./src/actions/timeline.js